import React, { Component } from 'react'
import Avatar from '../../avatar/Avatar'
import { avatarFromString } from '../../../utils/usercolor'
import moment from 'moment'
import Linkify from 'react-linkify'
import fontColorContrast from 'font-color-contrast'
import Color from 'color'

require('./message.scss')

export default class MessageView extends Component {
  render() {
    const bgColor = Color(this.props.color)
      .lighten(0.35)
      .desaturate(0.35)
      .alpha(0.8)
      .string()
    const textColor = fontColorContrast(this.props.color)

    const avatar = avatarFromString(this.props.nick)
    const hideNickAndAvatarClass = this.props.hideNicknameAndAvatar ? 'hidden' : ''
    const indentTextStyle = this.props.indentText ? {} : { marginLeft: '50px', marginTop: '-15px' }
    const alignMessageStyle = this.props.alignRight ? { alignSelf: 'flex-end' } : { alignSelf: 'flex-start' }

    return (
      <div className="single-modern-message" style={alignMessageStyle}>
        <div className={hideNickAndAvatarClass}>
          <Avatar image={avatar} color={this.props.color} nickname={this.props.nick} />
        </div>
        <div className="message-content-column" style={indentTextStyle}>
          <div className="message-row-1">
            <div className={`message-nickname ${hideNickAndAvatarClass}`} style={{ color: this.props.color }}>
              {this.props.nick}
            </div>
          </div>

          <div className="message-text" style={{ backgroundColor: bgColor }}>
            <Linkify properties={{ target: '_blank' }}>
              <span style={{ color: textColor }}>{this.props.text}</span>
            </Linkify>
          </div>
          <div className="message-timestamp">{moment(this.props.timestamp).format('h:mm a')}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/messages/modern/Message.jsx